export function createPollInFlightGuard() {
  let generation = 0;
  let inFlight = false;

  return {
    tryBegin() {
      if (inFlight) {
        return null;
      }

      inFlight = true;
      const startedAt = generation;

      return {
        isCurrent() {
          return startedAt === generation;
        },
        end() {
          if (startedAt === generation) {
            inFlight = false;
          }
        },
      };
    },
    invalidate() {
      generation += 1;
      inFlight = false;
    },
  };
}
